import { Injectable, Inject } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { ConfigurationActions } from '@actions/index';
import { CustomerActions } from '@actions/configuration/index';
import { OracleStorageService } from '@services/oracle-storage.service';
import { CustomerModel } from '@models/configuration/customer.model';


@Injectable()
export class CustomerEffects {
    // Customers Effects
    searchCustomers$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CustomerActions.searchCustomers),
            switchMap(({ action }) =>
                this.oracleStorageService
                    .search$(action)
                    .pipe(
                        map((Customers: CustomerModel[]) => CustomerActions
                            .searchCustomersSuccess({ Customers })
                        ),
                        catchError(error => of(ConfigurationActions.configurationError({ error }),CustomerActions.resetLoading()))
                    )
            ))
    );

    searchCustomersAuthorization$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CustomerActions.searchCustomersAuthorization),
            switchMap(({ action }) =>
                this.oracleStorageService
                    .search$(action)
                    .pipe(
                        tap((CustomersAuthorization:CustomerModel[])=>console.log(CustomersAuthorization)),
                        map((CustomersAuthorization: CustomerModel[]) => CustomerActions
                            .searchCustomersAuthorizationSuccess({ CustomersAuthorization })
                        ),
                        catchError(error => of(ConfigurationActions.configurationError({ error }),CustomerActions.resetLoading()))
                    )
            ))
    );

    createCustomers$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CustomerActions.createCustomer),
            switchMap(({ action }) =>
                this.oracleStorageService
                    .create$(action)
                    .pipe(
                        map((Customer: CustomerModel) => CustomerActions
                            .createCustomerSuccess({ Customer })
                        ),
                        catchError(error => of(ConfigurationActions.configurationError({ error }),CustomerActions.resetLoading()))
                    )
            ))
    );

    updateCustomers$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CustomerActions.updateCustomer),
            switchMap(({ action }) =>
                this.oracleStorageService
                    .update$(action)
                    .pipe(
                        map((Customer: CustomerModel) => CustomerActions
                            .updateCustomerSuccess({ Customer })
                        ),
                        catchError(error => of(ConfigurationActions.configurationError({ error }),CustomerActions.resetLoading()))
                    )
            ))
    );

    deleteCustomers$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CustomerActions.deleteCustomer),
            switchMap(({ action }) =>
                this.oracleStorageService
                    .delete$(action)
                    .pipe(
                        map((Customer: CustomerModel) => CustomerActions
                            .deleteCustomerSuccess({ Customer })
                        ),
                        catchError(error => of(ConfigurationActions.configurationError({ error }),CustomerActions.resetLoading()))
                    )
            ))
    );
    
    constructor(
        private actions$: Actions,
        @Inject('OracleStorageService') private oracleStorageService: OracleStorageService<CustomerModel>,
    ) { }
}